import { FunctionComponent, JSX, memo } from 'react';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

type CustomRenderProps = FunctionComponent<{ option: TReactSelectOption; idx: number; RemoveIcon?: JSX.Element }>;

const RenderFocusedLabelContent: CustomRenderProps = memo(({ option, RemoveIcon }) => {
  return (
    <div data-component="RenderFocusedLabelContent" className="flex ai-center gap-6">
      <div>{option.label}</div> <div>{RemoveIcon}</div>
    </div>
  );
});

RenderFocusedLabelContent.displayName = 'RenderFocusedLabelContent';

export default RenderFocusedLabelContent;
